import { LEGAL_DOCUMENTS } from "./public-collections.ts"
import { STATIC_PUBLIC_PAGES } from "./page-records.ts"
import type { PublicPage } from "./content-types.ts"

export { CONTENT_STATES } from "./content-types.ts"
export type { ContentState, FaqItem, LegalDocument, Notice, PublicPage } from "./content-types.ts"
export { LEGAL_DOCUMENTS }

export const PUBLIC_PAGES: readonly PublicPage[] = STATIC_PUBLIC_PAGES

const staticTraversalCases: Array<{ readonly id: PublicPage["id"]; readonly path: string }> = []
for (const page of PUBLIC_PAGES) {
  if (page.path !== "/notices/:id") staticTraversalCases.push({ id: page.id, path: page.path })
}

export const PUBLIC_TRAVERSAL_CASES = staticTraversalCases

export const getPageBySlug = (slug: string): PublicPage | undefined => PUBLIC_PAGES.find((page) => page.slug === slug)
